import Api from '../helpers/Api';
/**
 * Repository layer for Discount Admin tool 
 */
export default class DiscountToolRepository {
    /**
     * @property {Object} Api helper class, get/post data from/to back end
     */
    constructor() {
        this.api = new Api();
        this.errorMessage = "result is not a object";
    }

    /**
     * Post payload to Discount tool
     * @param {Object} params route && payload
     * @returns {Object} object response
     */
    postDataAsync = async (params) => {
        const response  = await this.api.postData(params.route, params.payload);
        
        if(typeof response === 'object' && response !== null) {
            if(response.status === 200) {
                return response.body;
            }
        } else {
            console.log(`Post ${this.errorMessage}`);
            return false;
        }
    };

    /**
     * Get data for SelectBox
     * @param {Object} params route && payload
     * @returns {Object} object response
     */
     fetchDataAsync = async (params) => {
        const response = await this.api.fetchData(params.route, null);
        const responseBody = { ...response.body };

        if (responseBody[0].Id === 'null') {
            return {responseValidate: false, body: responseBody[0].Name}; 
        }

        if(typeof response === 'object' && response !== null) {
            if(response.status === 200) {
                return {responseValidate: true, body: response.body}; 
            }
        } else {
            console.log(`Fetch ${this.errorMessage}`);
            return false;
        }
        
    };
}
